import React, { useState, useEffect } from 'react';
import { X } from 'lucide-react';

const CookieBanner = () => {
  const [showBanner, setShowBanner] = useState(false);
  const [showSettings, setShowSettings] = useState(false);
  const [preferences, setPreferences] = useState({
    necessary: true,
    analytics: false,
    marketing: false
  });

  useEffect(() => {
    const consent = localStorage.getItem('cookieConsent');
    if (!consent) {
      setShowBanner(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const acceptAll = () => {
    const allAccepted = {
      necessary: true,
      analytics: true,
      marketing: true
    };
    localStorage.setItem('cookieConsent', JSON.stringify(allAccepted));
    setShowBanner(false);
  };

  const acceptNecessary = () => {
    const necessaryOnly = {
      necessary: true,
      analytics: false,
      marketing: false
    };
    localStorage.setItem('cookieConsent', JSON.stringify(necessaryOnly));
    setShowBanner(false);
  };

  const savePreferences = () => {
    localStorage.setItem('cookieConsent', JSON.stringify(preferences));
    setShowBanner(false);
    setShowSettings(false);
  };

  const handlePreferenceChange = (type) => {
    if (type === 'necessary') return; // Always required
    setPreferences(prev => ({
      ...prev,
      [type]: !prev[type]
    }));
  };

  if (!showBanner) return null;

  return (
    <div className="cookie-banner-overlay">
      <div className="cookie-banner">
        <button 
          className="cookie-close"
          onClick={acceptNecessary}
          aria-label="Close"
        >
          <X size={20} />
        </button>

        {!showSettings ? (
          <>
            <h3>Cookie Preferences</h3>
            <p>
              We use cookies to enhance your browsing experience, analyze site traffic, 
              and provide personalized content. By clicking "Accept All," you consent to 
              our use of cookies in accordance with Spanish LOPD and GDPR regulations.
            </p>
            <div className="cookie-actions">
              <button 
                className="cookie-btn cookie-btn-primary"
                onClick={acceptAll}
              >
                Accept All
              </button>
              <button 
                className="cookie-btn cookie-btn-secondary"
                onClick={acceptNecessary}
              >
                Necessary Only
              </button>
              <button 
                className="cookie-btn cookie-btn-text"
                onClick={() => setShowSettings(true)}
              >
                Customize
              </button>
            </div>
          </>
        ) : (
          <>
            <h3>Cookie Settings</h3>
            <div className="cookie-settings">
              <div className="cookie-option">
                <div className="cookie-option-header">
                  <label>
                    <input
                      type="checkbox"
                      checked={preferences.necessary}
                      disabled
                    />
                    <span className="cookie-label">
                      <strong>Necessary Cookies</strong>
                      <span className="cookie-badge">Required</span>
                    </span>
                  </label>
                </div>
                <p className="cookie-description">
                  Essential for website functionality. Cannot be disabled.
                </p>
              </div>

              <div className="cookie-option">
                <div className="cookie-option-header">
                  <label>
                    <input
                      type="checkbox"
                      checked={preferences.analytics}
                      onChange={() => handlePreferenceChange('analytics')}
                    />
                    <span className="cookie-label">
                      <strong>Analytics Cookies</strong>
                    </span>
                  </label>
                </div>
                <p className="cookie-description">
                  Help us understand how visitors interact with our website.
                </p>
              </div>

              <div className="cookie-option">
                <div className="cookie-option-header">
                  <label>
                    <input
                      type="checkbox"
                      checked={preferences.marketing}
                      onChange={() => handlePreferenceChange('marketing')}
                    />
                    <span className="cookie-label">
                      <strong>Marketing Cookies</strong>
                    </span>
                  </label>
                </div>
                <p className="cookie-description">
                  Used to deliver relevant content and track campaign effectiveness.
                </p>
              </div>
            </div>

            <div className="cookie-actions">
              <button 
                className="cookie-btn cookie-btn-primary"
                onClick={savePreferences}
              >
                Save Preferences
              </button>
              <button 
                className="cookie-btn cookie-btn-text"
                onClick={() => setShowSettings(false)}
              >
                Back
              </button>
            </div>
          </>
        )}

        <p className="cookie-privacy">
          Read our <a href="/privacy">Privacy Policy</a> for more information.
        </p>
      </div>
    </div>
  );
};

export default CookieBanner;
